var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "control" }, [
    _c("div", { staticClass: "form-group" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.query,
            expression: "query"
          }
        ],
        staticClass: "form-control",
        class: _vm.className,
        attrs: {
          id: "app-search-input",
          type: "text",
          placeholder: _vm.control.placeholder
        },
        domProps: { value: _vm.query },
        on: {
          keyup: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            return _vm.updateFilters($event)
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.query = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "sr-only", attrs: { for: "app-search-input" } },
        [_vm._v("Search")]
      ),
      _vm._v(" "),
      _vm.query
        ? _c("button", {
            staticClass: "fas fa-times-circle search-clear",
            attrs: { type: "button", title: "Clear" },
            on: {
              click: function($event) {
                return _vm.clearSearchTerm()
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.control.searchButton
        ? _c(
            "button",
            {
              attrs: {
                type: "button",
                disabled: _vm.query == undefined || _vm.query.length == 0
              },
              on: { click: _vm.updateFilters }
            },
            [
              _c("span", { staticClass: "sr-only" }, [_vm._v("search")]),
              _c("i", { staticClass: "fas fa-search" })
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }